<template>
  <div class="points-content">
    <div class="banner">
      <div class="count">{{ pointsCount }} <span>分</span></div>
      <span class="enter" @click="$router.push('/points-list')">积分明细</span>
    </div>
    <!-- 每日签到 -->
    <div class="sign-wrap wrap">
      <div class="title">每日签到</div>
      <div class="status-wrap">
        <!-- 日期状态dateStatus -1 过去；  0 当日； 1 未来 -->
        <div v-for="(item, index) in signData" :key="index" class="item" :class="classNameOptions[item.dateStatus]">
          <!-- 漏签   -->
          <div v-if="item.dateStatus < 0 && item.signInStatus == 0" class="status">漏签</div>
          <!-- 已签到 -->
          <div v-else-if="item.signInStatus == 1" class="status">已<br />签到</div>
          <!-- 立即签到 -->
          <div v-else-if="item.dateStatus == 0 && item.signInStatus == 0" class="status" @click="bindSign">立即签到</div>
          <!-- 待签 -->
          <div v-else-if="item.dateStatus > 0 && item.signInStatus == 0" class="status">
            <span>+ 2</span>
            <img class="coin" src="@/assets/images/system/points/coin.png" />
          </div>
          <p>{{ item.day }}</p>
        </div>
      </div>
    </div>
    <!-- 任务 -->
    <div v-for="(item, index) in taskList" :key="index" class="wrap task">
      <div class="title">{{ item.name }}</div>
      <div v-for="(action, actionIndex) in item.items" :key="index + actionIndex" class="item" :class="[action.totalScores == action.userScores ? 'complete' : '']">
        <div class="icon">
          <img :src="action.ico" />
        </div>
        <div class="action">
          <div class="action-info">
            <p>{{ action.title }}</p>
            <div class="count">
              <img src="@/assets/images/system/points/coin.png" />
              <span>+ {{ action.totalScores }}</span>
            </div>
          </div>
          <p class="tip" v-if="item.id == 10">
            今天已获得积分
            <i>{{ action.userScores }}</i>
            <b>/{{ action.totalScores }}</b>
          </p>
        </div>
        <div v-if="action.totalScores != action.userScores && action.url" class="status-btn" @click="bindDispatch(action.url)">{{ action.appId | btnName }}</div>
        <div v-else-if="action.totalScores == action.userScores" class="status-btn">已完成</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCount, getWeekSign, getTaskList, updatePoints } from '@/service/system/points'
import * as tokenUtils from '@/utils/TokenUtils'
export default {
  name: 'MyPoints',
  data() {
    return {
      pointsCount: ' ',
      signData: [],
      classNameOptions: {
        '-1': 'date-0',
        '0': 'date-1',
        '1': 'date-2'
      },
      taskList: [],
      allowClick: true
    }
  },
  filters: {
    btnName(id) {
      let btnName = '去完成'
      switch (id) {
        case 10006:
          btnName = '去邀请'
          break
        case 10005:
          btnName = '去关注'
          break
      }
      return btnName
    }
  },
  mounted() {
    const that = this
    // window.SFApi.user.login(function (val) {
    //   if (val == 1 || val == -1) {
    //     const token = window.SFApi.user.getToken()
    //     tokenUtils.setToken(token)
    //     that.init()
    //   } else {
    //     window.SFApi.back()
    //   }
    // })
    if (window.SFApi.isInClient()) {
      window.SFApi.viewResume(function () {
        window.SFApi.user.login(function (val) {
          if (val == 1 || val == -1) {
            const token = window.SFApi.user.getToken()
            tokenUtils.setToken(token)
            that.init()
          } else {
            window.SFApi.back()
          }
        })
      })
    }
  },
  methods: {
    // getData
    async getCount() {
      const { data } = await getCount()
      this.pointsCount = data.total
    },
    // 获取每日签到
    async getWeekSign() {
      try {
        const data = await getWeekSign()
        this.signData = data.list
      } catch (error) {
        this.$toast(error)
      }
    },
    // 获取任务列表
    async getTaskList() {
      try {
        const { data } = await getTaskList()
        this.taskList = data.tasks
      } catch (error) {
        this.$toast(error)
      }
    },
    init() {
      this.getCount()
      this.getWeekSign()
      this.getTaskList()
    },
    // 签到
    async bindSign() {
      if (this.allowClick) {
        this.allowClick = false
        try {
          const { data } = await updatePoints('D29F1LEYC')
          this.$PointsTip(data.nums, data.eventNote)
          this.init()
          this.allowClick = true
        } catch (error) {
          this.allowClick = true
          this.$toast(error)
        }
      }
    },
    bindDispatch(url) {
      window.SFApi.dispatch(url)
    }
  }
}
</script>

<style lang="stylus" scoped>
.points-content
  background: #F7F9F9
  height: 100%
  overflow-y: auto
.banner
  height: 330px
  width: 100%
  background: url('../../../assets/images/system/points/banner.png') top no-repeat
  background-size: 100%
  position: relative
  .count
    font-size: 88px
    color: #fff
    position: absolute
    left: 50%
    transform: translateX(-50%)
    top 120px
    span
      font-size: 34px
  .enter
    font-size: 30px
    color: #fff
    position: absolute
    right: 28px
    top: 20px
.wrap
  width: 690px
  padding: 20px 20px 0 20px
  margin: 0 auto 20px
  border-radius: 15px
  background: #fff
  .title
    font-size: 32px
    line-height: 32px
    margin-bottom: 14px
    font-weight: bold
.daily-task,.task
  .item
    height: 120px
    display: flex
    align-items: center
    border-top: 1px solid #EEEEEE
    .icon
      width: 54px
      height: 54px
      margin-right: 16px
      img
        width: 100%
        display: block
    .action
      width: 500px
      .action-info
        display: flex
        align-items: center
        margin-bottom: 4px
        p
          margin-right: 24px
          font-size: 30px
          line-height: 42px
          color: #333
        .count
          display: flex
          align-items: center
          img
            width: 30px
            height: 30px
            margin-right: 10px
          span
            font-size: 28px
            color: #FE8402
      .tip
        font-size: 22px
        line-height: 30px
        i
          color: #2D8DFF
        b
          color: #333333
    &.complete .tip b,&.complete .tip i
      color: #999999
    .status-btn
      width: 100px
      height: 48px
      display: flex
      justify-content: center
      align-items: center
      border-radius: 24px
      font-size: 22px
      justify-self: flex-end
      background: #2D8DFF
      color: #fff
      flex-shrink: 0
  .complete .status-btn
    background: #eee
    color: #999
.sign-wrap
  height: 240px
  margin-top: -70px
  position: relative
  z-index: 1
  background: rgba(255,255,255,0.8)
  box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.05)
  backdrop-filter: blur(8px)
  .status-wrap
    display: flex
    justify-content: space-around
    .item
      text-align: center
      &.date-0
        .status
          background: #EEEEEE
          color: #999999
        p
          color: #999999
      &.date-1
        .status
          background: linear-gradient(135deg, #FEB609 0%, #FF7D01 100%)
          color: #fff
        p
          color: #FF8903
      &.date-2
        .status
          background: #fdf6e4
          color: #FF8903
        p
          color: #111111
      .status
        width: 68px
        height: 96px
        margin-bottom: 6px
        display: flex
        align-items: center
        align-content: center
        justify-content: center
        flex-wrap: wrap
        font-size: 28px
        line-height: 34px
        border-radius: 20px
        .coin
          display: block
          width: 40px
        // &.status-2
        //   background: linear-gradient(135deg, #FEB609 0%, #FF7D01 100%)
        // &.status-3
        //   background: #fdf6e4
      p
        font-size: 24px
        line-height: 34px
</style>
